import React, {
  useEffect,
} from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";
// Types
import { AppState } from "../../reducers";
import {
  decreaseTimer,
  showTimerWarning,
  showTimerExpired,
} from "./redux/reducer";

let interval: string | number | NodeJS.Timer | undefined;

const FlightTimer = () => {
  const dispatch = useDispatch();
  const timer = useSelector((state: AppState) => state.flight.timer);
  useEffect(() => {
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);
  useEffect(() => {
    if (timer === 1800) {
      interval = setInterval(() => dispatch(decreaseTimer()), 1000);
    }
    if (timer === 600) {
      dispatch(showTimerWarning());
    }
    if (timer === 0) {
      dispatch(showTimerExpired());
    }
  }, [timer]);
  return null;
};

export default FlightTimer;